import Component from '../core/Component'
import EventBus from '../core/EventBus'
import { disableScroll, enableScroll } from '../services/Scroll'

const States = {
    Active: 'is-active',
}

export default class Navigation extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            body: null,
            backdrop: null,
        }
    }

    prepare() {
        EventBus.on('swup:clicklink', this.handleSwupClick)

        this.ref.backdrop.addEventListener('click', this.handleBackdropClick)
    }

    destroy() {
        EventBus.off('swup:clicklink', this.handleSwupClick)
        document.removeEventListener('keydown', this.handleKeydown)
    }

    handleBackdropClick = () => {
        this.close()
    }

    handleSwupClick = () => {
        this.close()
    }

    handleKeydown = event => {
        if (event.key === 'Escape') {
            this.close()
        }
    }

    open() {
        this.element.classList.add(States.Active)
        document.addEventListener('keydown', this.handleKeydown)
        disableScroll()
    }

    close() {
        this.element.classList.remove(States.Active)
        document.removeEventListener('keydown', this.handleKeydown)
        enableScroll()
    }

    toggle() {
        if (this.element.classList.contains(States.Active)) {
            this.close()
        } else {
            this.open()
        }
    }
}
